import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = {
    key: 0,
    class: "d-block fs-4 text-muted"
};
const _hoisted_3 = { class: "rounded bg-white d-flex flex-wrap p-3 mb-3" };
const _hoisted_4 = { class: "form-floating" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "form-floating ms-3" };
const _hoisted_7 = ["value"];
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-12 col-lg-6" };
const _hoisted_10 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_11 = { class: "fs-3 fw-bold text-primary" };
const _hoisted_12 = { class: "col-12 col-lg-6" };
const _hoisted_13 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_14 = { class: "fs-3 fw-bold text-primary" };
const _hoisted_15 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_16 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_17 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_18 = { class: "row" };
const _hoisted_19 = { class: "col-12 col-lg-6" };
const _hoisted_20 = { class: "rounded bg-white p-3" };
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import StandardLoadingDisplay from '@/Shared/StandardLoadingDisplay.vue';
import BarChart from '@/Tenant/Components/BarChart.vue';
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head } from '@inertiajs/vue3';
import axios from 'axios';
import { onMounted, ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    setup(__props) {
        let { showErrorMessage } = responseMessages();
        let { formatCurrency } = formatters();
        const currentYear = new Date().getFullYear();
        const years = ref(Array.from({ length: currentYear - 2025 + 1 }, (_, i) => 2025 + i));
        const selectedYear = ref(0);
        const months = ref([
            { id: 1, name: 'Januar' },
            { id: 2, name: 'Februar' },
            { id: 3, name: 'März' },
            { id: 4, name: 'April' },
            { id: 5, name: 'Mai' },
            { id: 6, name: 'Juni' },
            { id: 7, name: 'Juli' },
            { id: 8, name: 'August' },
            { id: 9, name: 'September' },
            { id: 10, name: 'Oktober' },
            { id: 11, name: 'November' },
            { id: 12, name: 'Dezember' }
        ]);
        const selectedMonth = ref(0);
        const orderRequestData = ref(null);
        const percentualRelationOrdersToRequests = ref(null);
        const sales = ref(0);
        const orderRequestProductData = ref(null);
        const productSalesData = ref(null);
        const surveyAnswersData = ref(null);
        onMounted(() => {
            loadOrderRequestData();
            loadSalesData();
            loadOrderRequestProductData();
            loadProductSalesData();
            loadSurveyAnswersData();
        });
        watch(selectedYear, (newValue) => {
            loadOrderRequestData();
            loadSalesData();
            loadOrderRequestProductData();
            loadProductSalesData();
        });
        watch(selectedMonth, (newValue) => {
            loadOrderRequestData();
            loadSalesData();
            loadOrderRequestProductData();
            loadProductSalesData();
        });
        function loadOrderRequestData() {
            orderRequestData.value = null;
            axios.post(route('admin.dashboard.orderRequestData.load'), {
                year: selectedYear.value,
                month: selectedMonth.value,
            }).then((response) => {
                orderRequestData.value = response.data;
                const requestsSum = response.data.datasets[0].data.reduce((acc, val) => acc + val, 0);
                const ordersSum = response.data.datasets[1].data.reduce((acc, val) => acc + val, 0);
                percentualRelationOrdersToRequests.value = requestsSum > 0 ? (ordersSum / requestsSum) * 100 : 0;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function loadSalesData() {
            axios.post(route('admin.dashboard.salesData.load'), {
                year: selectedYear.value,
                month: selectedMonth.value,
            }).then((response) => {
                sales.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function loadOrderRequestProductData() {
            orderRequestProductData.value = null;
            axios.post(route('admin.dashboard.orderRequestProductData.load'), {
                year: selectedYear.value,
                month: selectedMonth.value,
            }).then((response) => {
                orderRequestProductData.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function loadProductSalesData() {
            productSalesData.value = null;
            axios.post(route('admin.dashboard.productSalesData.load'), {
                year: selectedYear.value,
                month: selectedMonth.value,
            }).then((response) => {
                productSalesData.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function loadSurveyAnswersData() {
            axios.post(route('admin.dashboard.surveyAnswersData.load')).then((response) => {
                surveyAnswersData.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Konfigurator 2.0" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, [
                            _cache[2] || (_cache[2] = _createTextVNode(" Statistiken ", -1)),
                            (selectedYear.value != 0 || selectedMonth.value != 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(selectedMonth.value == 0
                                    ? 'Alle Monate'
                                    : (months.value.find(m => m.id === selectedMonth.value) || {}).name) + " " + _toDisplayString(selectedYear.value != 0 ? selectedYear.value : 'Alle Jahre'), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    id: "year",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedYear).value = $event)),
                                    required: ""
                                }, [
                                    _cache[3] || (_cache[3] = _createElementVNode("option", { value: "0" }, "Gesamt", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                                        return (_openBlock(), _createElementBlock("option", { value: year }, _toDisplayString(year), 9, _hoisted_5));
                                    }), 256))
                                ], 512), [
                                    [_vModelSelect, selectedYear.value]
                                ]),
                                _cache[4] || (_cache[4] = _createElementVNode("label", { for: "year" }, "Jahr", -1))
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    id: "month",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedMonth).value = $event)),
                                    required: ""
                                }, [
                                    _cache[5] || (_cache[5] = _createElementVNode("option", { value: "0" }, "Gesamt", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            value: month.id
                                        }, _toDisplayString(month.name), 9, _hoisted_7));
                                    }), 256))
                                ], 512), [
                                    [_vModelSelect, selectedMonth.value]
                                ]),
                                _cache[6] || (_cache[6] = _createElementVNode("label", { for: "month" }, "Monat", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Bestellungen zu Anfragen/Angebote in %", -1)),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(percentualRelationOrdersToRequests.value ? percentualRelationOrdersToRequests.value.toFixed(2) : 0) + " %", 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Umsatz", -1)),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(formatCurrency)(sales.value)), 1)
                                ])
                            ])
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Anfragen/Angebote & Bestellungen", -1)),
                        _createElementVNode("div", _hoisted_15, [
                            (orderRequestData.value)
                                ? (_openBlock(), _createBlock(BarChart, {
                                    key: 0,
                                    xLabels: orderRequestData.value.labels,
                                    data: orderRequestData.value.datasets
                                }, null, 8, ["xLabels", "data"]))
                                : _createCommentVNode("", true),
                            (orderRequestData.value == null)
                                ? (_openBlock(), _createBlock(StandardLoadingDisplay, {
                                    key: 1,
                                    infoText: 'Daten werden geladen'
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("h3", null, "Anfragen/Angebote & Bestellungen pro Produkt", -1)),
                        _createElementVNode("div", _hoisted_16, [
                            (orderRequestProductData.value)
                                ? (_openBlock(), _createBlock(BarChart, {
                                    key: 0,
                                    xLabels: orderRequestProductData.value.labels,
                                    data: orderRequestProductData.value.datasets
                                }, null, 8, ["xLabels", "data"]))
                                : _createCommentVNode("", true),
                            (orderRequestProductData.value == null)
                                ? (_openBlock(), _createBlock(StandardLoadingDisplay, {
                                    key: 1,
                                    infoText: 'Daten werden geladen'
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Umsatz pro Produkt", -1)),
                        _createElementVNode("div", _hoisted_17, [
                            (productSalesData.value)
                                ? (_openBlock(), _createBlock(BarChart, {
                                    key: 0,
                                    xLabels: productSalesData.value.labels,
                                    data: productSalesData.value.datasets
                                }, null, 8, ["xLabels", "data"]))
                                : _createCommentVNode("", true),
                            (productSalesData.value == null)
                                ? (_openBlock(), _createBlock(StandardLoadingDisplay, {
                                    key: 1,
                                    infoText: 'Daten werden geladen'
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Bestell-Umfragen (alle Zeiträume)", -1)),
                                _createElementVNode("div", _hoisted_20, [
                                    (surveyAnswersData.value)
                                        ? (_openBlock(), _createBlock(BarChart, {
                                            key: 0,
                                            xLabels: surveyAnswersData.value.labels,
                                            data: surveyAnswersData.value.datasets
                                        }, null, 8, ["xLabels", "data"]))
                                        : _createCommentVNode("", true),
                                    (surveyAnswersData.value == null)
                                        ? (_openBlock(), _createBlock(StandardLoadingDisplay, {
                                            key: 1,
                                            infoText: 'Daten werden geladen'
                                        }))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-12 col-lg-6" }, null, -1))
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
